import { FileFormats } from "../../../../components/finalForms/libs/data/fileFormatTypes";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../data/formFieldType";

const initState = {
    documentName: '',
    psDocumentFileName: ''
}

export const addDocumentField = {
    name: "Document",
    initialState: initState,
    section: [
        {
            sectionId: "shippingAddressDetailSection",
            title: "Shipping Address Details Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-12",
            },
            wrapperTemplate: <div className="row"></div>,
            fields: [

                {
                    id: "documentName",
                    label: "Document : ",
                    Field_Name: "document name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "documentName",
                    fieldSetting: {
                        placeholder: "Enter Document Name",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-12 document-label",
                    },
                },
                {
                    id: "DocumentFileName",
                    label: "File Attachment :",
                    Field_Name: "attachment file",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "psDocumentFileName",
                    isRequired: true,
                    fieldSetting: {
                        placeholder: "Document File Name",
                        allowMultipleFiles: false,
                        isDownloadable: false,
                        minFileSizeInMB: 0, // Minimum File size in MB
                        maxFileSizeInMB: 8, // Maximum File size in MB
                        acceptedFileFormats: [
                            FileFormats.ALL
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss:
                            "col-lg-12 col-md-12 mb-2 ",
                    },
                },
            ]
        }
    ]
}